<template>
  <!-- ════ LOADING SCREEN — "The Machines Are In Motion" ════ -->
  <section style="text-align: center;">
    <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/gears-still.png" alt="loader" width="300" class="loader"/>
  </section>
</template>

<script>

</script>

<style scoped>
  .loader{
    margin: 200px auto;
  }
</style>